/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/aunjai-step3.css";
import ImageInput from "../../components/form/ImageInput/ImageInput.jsx";
import { useFileUpload } from "../../hooks/useFileUpload.js";
import { useLoanStore } from "../../stores/useLoanStore";
import Header from "../Header/stepHeader.jsx";
import FormPdpa from "../RegisterMain/FormPdpa.jsx";
import SelectInput from "../../components/form/SelectInput.jsx";
import { DOCUMENT_NAMES } from "../../constants/documents";
import { useTranslation } from "react-i18next";

const FillFormStep2 = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("form3");

  const BANK_NAME_OPTIONS = [
    { value: "KBANK", label: t("bank1") },
    { value: "SCB", label: t("bank2") },
    { value: "KTB", label: t("bank3") },
    { value: "BBL", label: t("bank4") },
    { value: "BAY", label: t("bank5") },
  ];
  const [bankName, setBankName] = useState("");

  const [bankAccount, setBankAccount] = useState("");

  const [isPdpaVisible, setIsPdpaVisible] = useState(false);

  const {
    fileInfo: bookBankFileInfo,
    propagateFileChange: propagateBookBankFileChange,
  } = useFileUpload(DOCUMENT_NAMES.BOOK_BANK);

  const setThirdFillFormData = useLoanStore(
    (state) => state.setThirdFillFormData
  );

  const goToStep5 = () => {
    if (!bookBankFileInfo) {
      return;
    }

    setIsPdpaVisible(true);
  };

  const handlePdpaConsent = async () => {
    setThirdFillFormData({
      bank_name: bankName,
      bank_account: bankAccount,
      attachment: [
        {
          name: DOCUMENT_NAMES.BOOK_BANK,
          file: bookBankFileInfo.file,
        },
      ],
    });
    navigate("/loan-process/form-step4");
  };

  return (
    <div id="pageFillForm3">
      {isPdpaVisible ? (
        <div style={{ marginTop: "50px" }}>
          <FormPdpa onAgree={handlePdpaConsent} header={true} />
        </div>
      ) : (
        <>
          <Header title={t("header")} showIcon={false} onBack={true} step={5} />
          <div className="wrapContent">
            <div id="pFillForm3">
              <div className="bFillForm">
                <div className="bContent">
                  <div className="bWarn">
                    <div className="bInside">
                      <p>{t("bankDesc")}</p>
                    </div>
                  </div>
                  <SelectInput
                    style={{ padding: "0 25px" }}
                    name="bank_name"
                    className="bInput"
                    label={t("inputBank")}
                    placeholder={t("inputBank")}
                    options={BANK_NAME_OPTIONS}
                    onChange={(e) => setBankName(e.target.value)}
                    isFormik={false}
                    value={bankName}
                  />
                  <div className="bInput">
                    <label>{t("bankId")}</label>
                    <input
                      type="number"
                      placeholder={t("inputSelectedBank")}
                      onChange={(e) => setBankAccount(e.target.value)}
                      value={bankAccount}
                    ></input>
                  </div>

                  <div className="bInput">
                    <ImageInput
                      {...propagateBookBankFileChange()}
                      remark={t("imageRemark")}
                      label={t("imageLabel")}
                      errorMessage={!bookBankFileInfo && t("imageError")}
                    />
                  </div>

                  <div className="bCheckbox">
                    <input type="checkbox" />
                    <label>
                      <span>{t("confirmAuto")}</span>
                      {t("confirmAuto2")}
                    </label>
                  </div>
                </div>
                <footer className="footer">
                  <div className="bBtn bActionButton">
                    <button
                      disabled={!bookBankFileInfo}
                      type="button"
                      onClick={goToStep5}
                    >
                      {t("confirm")}
                    </button>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FillFormStep2;
